module.exports = __webpack_public_path__ + "img/ritz-3.bbd71427.jpeg";